
export * from 'qiankun';

export interface FInitialConfig {
  app_id: string;
  // secret: string;
  prefetch?: boolean;
  signUrl: string;
  mode?: string; // 默认正式环境 development 为测试环境
}
export interface FMicroProps {
  loginUrl?: string, // 登录的重定向地址
  baseApiUrl?: string,
  dispatch?: (value: { type: string; data: any }) => void,
  pageInfo?: FPageConfig,
  useNativeRoute?: number;
  extra?: any,
}
export interface FLoadConfig {
  container: string;
  pageId: string;
  props?: FMicroProps;
}

export interface FRegisterConfig {
  entry: string;
  container?: string;
  props?: FMicroProps,
  activeRule: (location: Location) => boolean,
  loader: (loading: boolean) => void,
  pageId: string;
}

export interface MicroAppState {
  apps: string[], // 可以使用的产品
}

export interface FMicroEvent {
  type: string;
  data: any;
}

export interface FPageConfig {
  apiBaseUrl: string;
  appId: string;
  appName: string;
  appUrl: string;
  path: string;
  platform: string;
}

export enum TPlatforms {
  SMART_CONTACT_CMS = 'smart-contact-cms',
  INDUSTRY_PLATFORM = 'industry',
}
